<template>
  <div class="index">
    <div class="box">
      <el-date-picker class="report-date-picker"
        v-model="dates"
        :editable="false"
        type="daterange"
        placeholder="Выберите период">
      </el-date-picker>
      <a class="button" @click="loadNewsReport(dates)">Скачать отчет</a>
    </div>
    <router-link :to="{ name: 'NotificationEditor', params: { id: 'new' } }" class="button is-fullwidth">Добавить новость</router-link>
    <ul class="list column is-8 is-offset-2">
      <router-link v-for="article in news" :to="{ name: 'NotificationEditor', params: { id: article.id } }" tag="li" class="box" :key="article.id">
        <strong>{{ article.title }}</strong> - <strong>{{ article.publishDate | formatDate }}</strong>
        <button class="delete is-pulled-right" @click.stop="del(article.id)"></button>
        <p>{{ article.text.replace(/(<([^>]+)>)/ig,"") | stripHTML | truncate(140) }}</p>
      </router-link>
    </ul>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'News',
    data () {
      return {
        dates: null
      }
    },
    computed: {
      ...mapState(['news', 'clients'])
    },
    created () {
      this.getNotifications()
      this.getClients()
    },
    methods: {
      ...mapActions(['getNotifications', 'deleteArticle', 'getClients', 'loadNewsReport']),
      del (id) {
        this.$dialog.confirm({
          message: 'Действительно удалить?',
          onConfirm: () => {
            this.deleteArticle(id)
            .then(() => this.$toast.open({
              message: 'Статья удалена'
            }))
          }
        })
      }
    }
  }
</script>

<style>
.report-date-picker {
  margin: 0 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// Index.vue?df841af6